import { ready, recaptcha } from '../../utils/functions';
import { BounceWatcher } from './BounceWatcher';
import { Bouncer } from './Bouncer';
import { LarchSys } from '../../utils/larchSys';


export class NewsletterPopup {
    private bounce = new BounceWatcher('nlppp-disabled');
    private $popup = document.querySelector('.nlppp') as HTMLElement;

    init() {
        if (!this.$popup) {
            return;
        }

        this.bounce.init(this.show.bind(this));

        const $form = this.find<HTMLFormElement>('.nlppp-form');
        Bouncer('.nlppp .nlppp-form', { disableSubmit: true });

        $form.addEventListener('bouncerFormValid', e => {
            e.preventDefault();

            this.hideError();
            this.loading(true);

            recaptcha(this.find('grecaptcha')).then(() => {

                window.fetch($form.action, { method: $form.method, body: new FormData($form) })
                    .then(response => {
                        if (response.ok) {
                            this.showSuccess();
                            this.bounce.disable(365);
                        }
                        else {
                            response.text()
                                .then(json => Promise.resolve().then(_ => JSON.parse(json).error as string).catch(_ => json))
                                .then(error => this.showError(error || 'Error'));
                        }
                    })
                    .catch(error => {
                        this.showError(error || 'Error');
                    })
                    .finally(() => {
                        this.loading(false);
                    });

            });
        });
    }

    show() {
        if (!this.$popup) {
            console.info('nl popup disabled');
            return;
        }

        this.loading(false);
        this.showForm();

        // show without fancybox: =========================================\
        this.$popup.style.display = '';
        this.find('.fancybox-close-small').addEventListener('click', () => {
            this.$popup.classList.remove('show');
            this.bounce.disable(1);
        });

        document.body.appendChild(this.$popup);

        requestAnimationFrame(() => this.$popup.classList.add('show'));
        // ===========================================================/

        //$.fancybox.open({
        //    src: '.nlppp',
        //    type: 'inline',
        //    afterClose: () => {
        //        this.bounce.disable(1);
        //    }
        //});
    }


    private showForm() {
        this.find('.nlppp-success').style.display = 'none';
        this.find('.nlppp-errors').style.display = 'none';
        this.find('.nlppp-form').style.display = '';
    }

    private showSuccess() {
        this.find('.nlppp-success').style.display = '';
        this.find('.nlppp-errors').style.display = 'none';
        this.find('.nlppp-form').style.display = 'none';
    }

    private showError(error: string) {
        this.find('.nlppp-errors').style.display = '';
        this.find('.nlppp-errors').innerHTML = error;
    }

    private hideError() {
        this.find('.nlppp-errors').style.display = 'none';
        this.find('.nlppp-errors').innerHTML = '';
    }

    private loading(show: boolean) {
        const btn = this.find<HTMLInputElement>('.nlppp-submit');
        if (show) {
            btn.querySelector('.load-spinner').classList.add('spin');
            btn.disabled = true;
        }
        else {
            btn.querySelector('.load-spinner').classList.remove('spin');
            btn.disabled = false;
        }
    }


    private find<T extends Element = HTMLElement>(selector: string) {
        return this.$popup.querySelector(selector) as T;
    }
}


export function newsletterPopupFeature(larchSys: LarchSys) {

    const newsletterPopup = new NewsletterPopup();

    // export global
    Object.assign(global, {
        popup: () => newsletterPopup.show()
    });

    ready(() => {
        newsletterPopup.init();
    });

}